import { cx } from '@emotion/css';
import { useMediaQuery } from '@sortlist-frontend/design-system/legacy';
import { ImageSourceHelper } from '@sortlist-frontend/media';
import { useTranslation } from '@sortlist-frontend/translation/ssr';

import { usePublicAppContext } from '_core/context/public-app-context';
import { onImageError } from '_core/media/get-media.utils';
import { homeConfig } from '_features/home/home.config';
import * as S from '_features/home/sections/JoinAsAgency/styles';

export const JoinAsAgency = () => {
  const { t } = useTranslation(homeConfig.i18nNamespaces);
  const s3BucketUrl = process.env.NEXT_PUBLIC_S3_BUCKET;
  const { media_legacy } = useMediaQuery();
  const { getUrl } = usePublicAppContext();

  return (
    <section className="bg-supply-200 py-16">
      <div className="container-lg layout-column layout-align-start-center">
        <header className="layout-column layout-align-start-start layout-align-gt-xs-center-center mb-12">
          <div className="bg-supply-300 py-2 px-4 rounded-xl layout-row layout-align-center-center text-supply-700">
            <S.StoreIcon />
            <span className="px-2 medium">{t('home:sections.join.subtitle_V2')}</span>
          </div>
          <h2 className={cx(media_legacy.gtXs ? 'text-center' : 'text-left', 'h1 mt-4 bold')}>
            {t('home:sections.join.title_V2')}
          </h2>
        </header>
        <S.RoundedContainer className="layout-column layout-gt-xs-row mb-8 bg-supply-900">
          <div className="flex-1 layout-column layout-align-center-start p-6 lg:p-16 flex-order-1">
            <h3 className="h2 text-supply-200 bold mb-4">{t('home:sections.join.revenue')}</h3>
            <p className="text-supply-300"> {t('home:sections.join.description_V2')}</p>
            <a href={getUrl('providers')} className="text-primary-900 bg-neutral-50 p-4 rounded-lg mt-8">
              {t('home:sections.join.getListed')}
            </a>
          </div>
          <div className="p-2 layout-row layout-align-center-center flex-1 flex-order-gt-xs-2">
            <div className="relative layout-row layout-align-center-center flex-1">
              <S.Img
                src={ImageSourceHelper.fromUrl(`${s3BucketUrl}/illustrations/home/join-providers.webp`, {
                  width: 512,
                })}
                alt={'Join providers'}
                onError={onImageError}
                width={490}
                height={420}
                className="rounded-xl "
              />
            </div>
          </div>
        </S.RoundedContainer>
      </div>
    </section>
  );
};
